import { useEffect } from 'react'
import Close from '../asset/img/modal-close.svg'

export const ViewNotificationImagePopup = ({ onClose, data }) => {
    useEffect(() => {
        console.log(data, 'image-url')
    }, [data])

    return (
        <>
            <div
                className="modal d-block"
                id="view-multi-modal"
                tabIndex="-1"
                aria-labelledby="view-multi-modal"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered modal-lg planogram-div">
                    <div className="modal-content rounded-0 p-2">
                        <img
                            id="close"
                            src={Close}
                            alt="X"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            className="modal-close"
                            onClick={() => onClose()}
                        />

                        <div className="modal-header rounded-0 align-items-center py-4 px-4">
                            <div className="col">
                                <h4 className="modal-title">Notification Image</h4>
                            </div>
                        </div>

                        <div className="modal-body font14 p-40">
                            <div
                                className="container"
                                style={{ height: '60vh', display: 'flex', justifyContent: 'center' }}
                            >
                                <div className="row mt-3">
                                    <img
                                        src={data}
                                        alt="Suspicious"
                                        crossOrigin="anonymous"  
                                        style={{
                                            width: '100%',
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="text-end">
                            <button
                                className="btn btn-primary submitRoom"
                                style={{ marginLeft: '20px' }}
                                onClick={() => onClose()}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal-backdrop show"></div>
        </>
    )
}
